var WelcomePanel = require( './welcome-panel' );

WelcomePanel();


// WEBPACK FOOTER //
// ./client/jetpack-onboarding.js